import { ICashRaffleTicketReleaseQueueDTO } from "./ICashRaffleTicketReleaseQueueDTO";

export enum CashTypeEnum {
  CREDIT = "c",
  DEBIT = "d",
  CANCELED = "x",
  HIDDEN = "h",
}

export type CashTypeTypes = `${CashTypeEnum}`;

export enum CashOpIdEnum {
  CLIENT_PAY_IN = 1,
  CUSTOMER_DEPOSIT = 2,
  CUSTOMER_COMMISSION_RECEIVED = 3,
  CUSTOMER_TICKET_SALE_PROFIT = 4,
  CUSTOMER_WITHDRAW = 101,
  CUSTOMER_WITHDRAW_FEE = 102,
  CUSTOMER_COMMISSION_SENT = 103,
}

export enum CashOpTypeEnum {
  CREDIT = "c",
  DEBIT = "d",
  CANCELED = "x",
}

export type CashOpTypeTypes = `${CashOpTypeEnum}`;

export interface ICashTypeDTO {
  type: string;
  text: string;
  title: string;
  color: string;
}

export interface ICashGroupDTO {
  id: number | string;
  name: string;
  text?: string;
}

export interface ICashOpDTO {
  id: number | string;
  group: number | string;
  name: string;
  type: CashOpTypeTypes;
  text?: string;
  title?: string;
  color?: string;
}

export interface ICashValueRetDTO {
  sign: string;
  color: string;
}

export interface ICashDTO {
  id: number;
  hash: string;
  customerId: number;
  customer: string;
  op?: number | string;
  opData?: ICashOpDTO;
  groupData?: ICashGroupDTO;
  type: CashTypeTypes;
  amountGross: number;
  amount: number;
  balance: number;
  locked: boolean;
  originId?: string;
  originType?: string;
  releaseAt: string;
  data: string;
  createdAt: string;
  cashRaffleTicketReleaseQueueData?: ICashRaffleTicketReleaseQueueDTO;
}

export interface ICashInsertDTO {
  id: number;
  encryptedId: string;
  admin: string;
  user: string;
  email: string;
  op: string;
  type: "c" | "d";
  value: number;
  dateReq: Date;
  dateClose: Date;
  locked: "y" | "n";
  status: "a" | "n" | "p";
}

